import React from 'react';
import {
  Form, Row, Col, Avatar, Typography, Input, Button, Card
} from 'antd';
import { useTranslation } from 'react-i18next';

import styles from './ResetPassword.module.less';
import SelectLanguage from '@common/containers/Header/SelectLanguage/SelectLanguage'; 
import { LockOutlined } from '@ant-design/icons';
 
import useResetPassword from './useResetPassword';

const { Item } = Form; 
const imagePath = 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/User-avatar.svg/2048px-User-avatar.svg.png';
const { Title, Paragraph } = Typography;

const windowsWidth = window.screen.width;
function ResetPassword() {

  const { t } = useTranslation();
  const {
    onUserResetPassword,
    loading
  } = useResetPassword();
 
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        
        <Card style={{width: windowsWidth > 1200 ? windowsWidth*0.4:windowsWidth-50 }}>
          <div>

            {/* Titulo */}
            <Row gutter={16} align="middle">
              <Col span={24}> 
                  <h2 style={{marginBottom:15}}>{t('common.restore_password')}</h2>
              </Col>
            </Row> 

            {/* Segunda fila */}
            <Form id="myForm" layout="vertical" onFinish={onUserResetPassword}>
              <Row gutter={16} style={{marginTop:25}}> 
                <Col span={24}>
                  
                    <Item
                      className={styles.label}
                      label={t('forms.recovery_password.change_password.new_password')}
                      name="new_password" 
                      rules={[
                        { required: true, message: t('forms.users.feedbacks.field_req') },
                      ]}
                    >
                      <Input.Password
                        size="large"
                        prefix={<LockOutlined />}
                        placeholder={t('forms.recovery_password.change_password.new_password')}
                      />
                    </Item>

                    <Item
                      className={styles.label}
                      label={t('forms.recovery_password.change_password.repeat_new_password')}
                      name="repeat_new_password"
                      rules={[
                        { required: true, message: t('forms.users.feedbacks.field_req') },
                      ]}
                    >
                      <Input.Password
                        size="large"
                        prefix={<LockOutlined />}
                        placeholder={t('forms.recovery_password.change_password.new_password')}
                      />
                    </Item>
                  
                </Col>
              </Row> 

              <Row style={{ justifyContent:'end'}}> 
                  <Button key="button" className='m_l' type="primary" htmlType="submit" loading={loading} >
                    {t('forms.users.buttons.update')}
                  </Button> 
              </Row> 
            </Form> 
          </div>
        </Card>
      </div>
      <SelectLanguage className={styles.select_language} />
    </div>
  );

}

export default ResetPassword;
